import { BlogsShortMessageFormData } from "@/mk2/apps/blogs/components/BlogsShortMessageCreateEditForm";
import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";
import { PostVisibility } from "@/mk2/schemas";

/////////////////////////////////////////////////////////////////////
// Post Create Load

export const BLOGS_SHORT_MESSAGE_CREATE_FETCH_TRIGGER = "BLOGS_SHORT_MESSAGE_CREATE_FETCH_TRIGGER";
export interface BlogsShortMessageCreateFetchTriggerAction {
    readonly type: typeof BLOGS_SHORT_MESSAGE_CREATE_FETCH_TRIGGER;
    readonly username: string;
}
export const BLOGS_SHORT_MESSAGE_CREATE_FETCH_REQUEST = "BLOGS_SHORT_MESSAGE_CREATE_FETCH_REQUEST";
export interface BlogsShortMessageCreateFetchRequestAction extends APIRequestAction {
    readonly type: typeof BLOGS_SHORT_MESSAGE_CREATE_FETCH_REQUEST;
    readonly username: string;
}
export interface BlogsShortMessageCreateFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        defaultPostVisibility: PostVisibility;
    };
}
export const BLOGS_SHORT_MESSAGE_CREATE_FETCH_SUCCESS = "BLOGS_SHORT_MESSAGE_CREATE_FETCH_SUCCESS";
export interface BlogsShortMessageCreateFetchSuccessAction extends APISuccessAction<BlogsShortMessageCreateFetchNormalizedResponse> {
    readonly type: typeof BLOGS_SHORT_MESSAGE_CREATE_FETCH_SUCCESS;
    readonly username: string;
}
export const BLOGS_SHORT_MESSAGE_CREATE_FETCH_FAILURE = "BLOGS_SHORT_MESSAGE_CREATE_FETCH_FAILURE";
export interface BlogsShortMessageCreateFetchFailureAction extends APIFailureAction {
    readonly type: typeof BLOGS_SHORT_MESSAGE_CREATE_FETCH_FAILURE;
    readonly username: string;
}

export const blogsShortMessageCreateFetchTrigger = (
    username: string,
): BlogsShortMessageCreateFetchTriggerAction => ({
    type: BLOGS_SHORT_MESSAGE_CREATE_FETCH_TRIGGER,
    username,
});
export const blogsShortMessageCreateFetchApi = {
    request: (username: string): BlogsShortMessageCreateFetchRequestAction => ({
        type: BLOGS_SHORT_MESSAGE_CREATE_FETCH_REQUEST,
        username,
    }),
    success: (
        username: string,
        response: BlogsShortMessageCreateFetchNormalizedResponse,
    ): BlogsShortMessageCreateFetchSuccessAction => ({
        type: BLOGS_SHORT_MESSAGE_CREATE_FETCH_SUCCESS,
        username,
        response,
    }),
    failure: (username: string, error: string): BlogsShortMessageCreateFetchFailureAction => ({
        type: BLOGS_SHORT_MESSAGE_CREATE_FETCH_FAILURE,
        username,
        error,
    }),
};

/////////////////////////////////////////////////////////////////////
// Post Create Save

export const BLOGS_SHORT_MESSAGE_CREATE_SAVE_TRIGGER = "BLOGS_SHORT_MESSAGE_CREATE_SAVE_TRIGGER";
export interface BlogsShortMessageCreateSaveTriggerAction {
    readonly type: typeof BLOGS_SHORT_MESSAGE_CREATE_SAVE_TRIGGER;
    readonly username: string;
    readonly postFd: BlogsShortMessageFormData;
}
export const BLOGS_SHORT_MESSAGE_CREATE_SAVE_REQUEST = "BLOGS_SHORT_MESSAGE_CREATE_SAVE_REQUEST";
export interface BlogsShortMessageCreateSaveRequestAction extends APIRequestAction {
    readonly type: typeof BLOGS_SHORT_MESSAGE_CREATE_SAVE_REQUEST;
    readonly username: string;
    readonly postFd: BlogsShortMessageFormData;
}
export interface BlogsShortMessageCreateSaveNormalizedResponse extends NormalizedResponse {
    readonly result: { post: number };
}
export const BLOGS_SHORT_MESSAGE_CREATE_SAVE_SUCCESS = "BLOGS_SHORT_MESSAGE_CREATE_SAVE_SUCCESS";
export interface BlogsShortMessageCreateSaveSuccessAction extends APISuccessAction<BlogsShortMessageCreateSaveNormalizedResponse> {
    readonly type: typeof BLOGS_SHORT_MESSAGE_CREATE_SAVE_SUCCESS;
    readonly username: string;
    readonly postFd: BlogsShortMessageFormData;
}
export const BLOGS_SHORT_MESSAGE_CREATE_SAVE_FAILURE = "BLOGS_SHORT_MESSAGE_CREATE_SAVE_FAILURE";
export interface BlogsShortMessageCreateSaveFailureAction extends APIFailureAction {
    readonly type: typeof BLOGS_SHORT_MESSAGE_CREATE_SAVE_FAILURE;
    readonly username: string;
    readonly postFd: BlogsShortMessageFormData;
}

export const blogsShortMessageCreateSaveTrigger = (
    username: string,
    postFd: BlogsShortMessageFormData,
): BlogsShortMessageCreateSaveTriggerAction => ({
    type: BLOGS_SHORT_MESSAGE_CREATE_SAVE_TRIGGER,
    username,
    postFd,
});
export const blogsShortMessageCreateSaveApi = {
    request: (
        username: string,
        postFd: BlogsShortMessageFormData,
    ): BlogsShortMessageCreateSaveRequestAction => ({
        type: BLOGS_SHORT_MESSAGE_CREATE_SAVE_REQUEST,
        username,
        postFd,
    }),
    success: (
        username: string,
        postFd: BlogsShortMessageFormData,
        response: BlogsShortMessageCreateSaveNormalizedResponse,
    ): BlogsShortMessageCreateSaveSuccessAction => ({
        type: BLOGS_SHORT_MESSAGE_CREATE_SAVE_SUCCESS,
        username,
        postFd,
        response,
    }),
    failure: (
        username: string,
        postFd: BlogsShortMessageFormData,
        error: string,
    ): BlogsShortMessageCreateSaveFailureAction => ({
        type: BLOGS_SHORT_MESSAGE_CREATE_SAVE_FAILURE,
        username,
        postFd,
        error,
    }),
};
